/**
 * ModalHeader Component
 *
 * Header for the onboarding modal with logo and close button.
 *
 * @module components/onboarding/ModalHeader
 */

import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Image,
  CloseIcon,
  BRAND_NAME,
  BRAND_LOGO_ALT,
} from "../../design-system";
import logo from "../../../assets/brand/logo_site.svg";
interface ModalHeaderProps {
  onClose: () => void;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ onClose }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "24px 32px",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <Image src={logo} alt={BRAND_LOGO_ALT} height={32} />
        <Typography variant="headingLarge" color="white">
          {BRAND_NAME}
        </Typography>
      </Box>
      <IconButton onClick={onClose} ariaLabel="Close modal">
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

export default ModalHeader;
